import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CleanupRegistryService } from '@app/core/services/registry/cleanup-registry.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CleanupResolverService implements Resolve<boolean> {
  constructor(protected cleanupRegistryService: CleanupRegistryService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.cleanupRegistryService.cleanup();
    return of(true);
  }
}
